import React from 'react';
import PropTypes from 'prop-types';
import Radio from '../../../components/UI/MDC/Radio/Radio';
import RadioSet from '../../../components/UI/MDC/Radio/RadioSet/RadioSet';
import * as utils from '../../../utils';

const YesNoRadioButton = props => {
    const { title } = props;
    const combinedRadioButtonStyles = [];
    if (props.className) {
        combinedRadioButtonStyles.push(props.className);
    }
    return (
        <React.Fragment>
            <div
                className={utils.concatenateClassNames(
                    ['input__radio--full-width', 'input__radio__container'],
                    combinedRadioButtonStyles
                )}
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <h4 style={{ fontSize: '18px' }}>{title}</h4>
                <RadioSet changeHandler={props.onChange}>
                    <Radio
                        label={'Yes'}
                        value={'Yes'}
                        checked={props.value === 'Yes'}
                    />
                    <Radio
                        label={'No'}
                        value={'No'}
                        checked={props.value === 'No'}
                    />
                </RadioSet>
            </div>
        </React.Fragment>
    );
};

YesNoRadioButton.propTypes = {
    formDetails: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    validationMessage: PropTypes.string,
    valid: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default YesNoRadioButton;